import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    outflows: [],
    outflow: {}
  },
  mutations: {
    index(state, payload) {
      state.outflows = payload
    },
    show(state,payload) {
      state.outflow = payload
    }
  },
  actions: {
    index ({commit}) {
      axios.get(`${ENV.API_URL}/api/outflows`).then((res) => {
        commit('index', res.data)
      })
    },
    show({commit}, payload) {
      axios.get(`${ENV.API_URL}/api/outflows/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({commit}, payload) {
      axios.post(`${ENV.API_URL}/api/outflows`, payload).then((res) => {
        commit('show', res.data)
      })
    },
    uptade({commit}, payload) {
      axios.put(`${ENV.API_URL}/api/outflows/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    outflows: state => {
      return state.outflows
    },
    outflow: state => {
      return state.outflow
    }
  },
  modules: {
  }
}
